import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from 'ui';

import { useCreateAccount } from '~/onboarding';
import { StepTitle } from '~/ui';

export const RegisterIntroductionStep = () => {
  const { t } = useTranslation();
  const { goToNextStep } = useCreateAccount();

  return (
    <Box display="flex" flex={1} flexDirection="column" justifyContent="space-between">
      <Box display="flex" flexDirection="column" gap={2}>
        <StepTitle>{t('register:process:description')}</StepTitle>

        <Typography variant="body1">{t('register:process:email')}</Typography>
        <Typography variant="body1">{t('register:process:phoneNumber')}</Typography>
        <Typography variant="body1">{t('register:process:password')}</Typography>
      </Box>

      <Box>
        <Button data-testid="continue-button" size="lg" fullWidth onClick={goToNextStep} color="gradient">
          {t('common:continue')}
        </Button>
      </Box>
    </Box>
  );
};
